import { config } from "~initializer/config.ts";

export function currentRelease() {
  return config().gitSha || "unknown";
}
